import React from "react";

function VenueIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(3)">
          <path d="M3.564 16c1.97 0 3.563-1.122 3.563-2.5V4.628L9.45 3.96c.433-.125.732-.516.732-.961v-2a.991.991 0 00-.41-.801A1.027 1.027 0 008.876.04L5.803.932a1 1 0 00-.712.953v9.337a4.828 4.828 0 00-1.527-.25c-1.969 0-3.564 1.094-3.564 2.5S1.594 16 3.564 16z"></path>
        </g>
      </g>
    </svg>
  );
}

export default React.memo(VenueIcon);
